import React from 'react'
import PropTypes from 'prop-types'
import { Label } from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'
import { statusColor, approveStatus } from '../helpers/color'
import * as CONSTANTS from '../constants'
import { FONTS } from '../../../constants'
import moment from '../../../lib/moment.js'

export const TimesheetStatus = (props) => {
  const { timesheetRequest, timesheets } = props
  const users = get(timesheets, 'users', [])
  const status = approveStatus(get(timesheetRequest, 'timesheetRequest.status'))
  const remark = approveStatus(get(timesheetRequest, 'timesheetRequest.remark_request_user'))
  const submited = get(timesheetRequest, 'timesheetRequest.created')
  const approved = get(timesheetRequest, 'timesheetRequest.updated')
  const month = get(timesheetRequest, 'timesheetRequest.timesheet_snapshot.month')
  const user = find(users, { _id: get(timesheetRequest, 'timesheetRequest.user_id') })
  const color = statusColor(get(timesheetRequest, 'timesheetRequest.status'))

  return (
    <Wrapper>
      <GroupLabel>
        <Title>Status</Title>
        <Detail color={ color }>
          <Circle color={ color } />
          { status }
        </Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>Month:</Title>
        <Detail>{ month ? moment(month).format('MMMM') : '-' }</Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>Year:</Title>
        <Detail>{ month ? moment(month).format('YYYY') : '-' }</Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>Emp. Name</Title>
        <Detail>{ user ? `${user.emp_code} - ${user.first_name} ${user.last_name} (${user.nick_name})` : '-' }</Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>LOB</Title>
        <Detail>{ user ? user.lob_name : '-' }</Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>Submitted Date</Title>
        <Detail>{ moment(submited).format('DD/MM/YYYY') }</Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>Approved Date</Title>
        <Detail>{ status === CONSTANTS.APPROVED ? moment(approved).format('DD/MM/YYYY') : '-' }</Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>Submit Remark</Title>
        <Detail>{ remark || '-' }</Detail>
      </GroupLabel>
    </Wrapper>
  )
}

TimesheetStatus.propTypes = {
  timesheetRequest: PropTypes.object,
  timesheets: PropTypes.object,
}
TimesheetStatus.defaultProps = {
  timesheetRequest: {},
  timesheets: {},
}


const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin-top: 10px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
`
const GroupLabel = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 2%;
`
const Title = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  color: #A9A9A9;
  margin-right: 10px;
  margin-bottom: 0px;
  font-size: 10px;
`
const Detail = styled.span`
  display: flex;
  text-align: center;
  margin-right: 10px;
  font-size: ${FONTS.SMALL_SIZE};
  color: ${props => props.color};
`
const Circle = styled.div`
  font-size: 15px;
  color: #FFFFFF;
  text-align: center;
  line-height: 15px;
  height: 10px;
  width: 10px;
  background-color: ${props => props.color};
  border-radius: 50%;
  margin: 5px;
  margin-left: 0px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/status-bar/timesheet-status.js